import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementArtifact/CreditAgreement';
import { CreditAgreementsOverview } from 'packages/creditAgreements/ui/CreditAgreementArtifact/CreditAgreementsOverview';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

export const CreditAgreementsRoute = () => {
  const { user } = useUserAuthOrThrow();
  const organizationId = user.organizationId;

  // Paths relative to "/credit-agreements/*"
  return (
    <Routes>
      <Route path="/" element={<CreditAgreementsOverview />} />
      <Route
        path="/:creditAgreementId"
        element={<CreditAgreement organizationId={organizationId} />}
      />
    </Routes>
  );
};
